export default class GoogleAdsEvent {
    hitType: string = 'event';
    event: {
        send_to: string;
        value: number;
        currency: string;
        transaction_id: string;
    };

    constructor(send_to: string, value?: number, currency?: string, transaction_id?: string) {
        this.event = {
            send_to,
            value,
            currency,
            transaction_id,
        };
    }
}
